// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"b8fe19b4","59":"af33bea1","245":"ded00097","264":"61da5a27","867":"b8c53be3","994":"353fed5f"}[chunkId] + ".chunk.css";
};